import script from "./Purchase.vue?vue&type=script&setup=true&lang=js"
export * from "./Purchase.vue?vue&type=script&setup=true&lang=js"

export default script